import { CommmonFilterLabel, FiltersNameEnum, useFiltersLabel as useFiltersLabelBlocs } from '@blocs.filter';
import { useTranslation } from '@blocs.i18n';
import { AppType } from '@blocs.common';

export const useFiltersLabel = (): CommmonFilterLabel => {
  const { t } = useTranslation();

  return {
    ...useFiltersLabelBlocs(AppType.Reps),
    [FiltersNameEnum.seekingRepresentation]: t('common:filtersName.seekingRepresentation'),
    [FiltersNameEnum.representativeList]: t('common:filtersName.repList'),
    [FiltersNameEnum.gender]: t('common:filtersName.genderAppearance'),
  };
};
